import React from 'react'
import Widget from './Widget'
import Views from './quiz/views'

const Question = props => props.children || null
Question.displayName = 'QuizQuestion'

const QuestionForm = props => props.children || null
QuestionForm.displayName = 'QuizQuestionForm'

const QuestionFeedback = props => props.children || null
QuestionFeedback.displayName = 'QuizQuestionFeedback'

export const Quiz = {
  ...Views,
  Widget,
  Question,
  QuestionForm,
  QuestionFeedback,
}

export { default as QuizProvider } from './quiz/Quiz'